// Home.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GlassBox from '../GlassBox/GlassBox';
import HeroScan from '../HeroScan/HeroScan';
import AccessibilityPanel from '../AccessibilityPanel/AccessibilityPanel';
import homeImg from '../../assets/home_img.png';

// The live LiDAR scene (HeroScan) in place of the hero photo. Off for now: the photo shows.
// true brings the scene back; the photo stays as its fallback either way.
const SHOW_HERO_SCAN = false;

const Home = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Preload the background image
    const img = new Image();
    img.src = homeImg;
    img.onload = () => setImageLoaded(true);
    
    // Set loaded immediately to prevent flash
    setImageLoaded(true);
  }, []);

  return (
    <div className={`HomeImg ${imageLoaded ? 'image-loaded' : 'image-loaded'}`}>
      {SHOW_HERO_SCAN && <HeroScan />}
      <GlassBox onLoginClick={() => navigate('/login')} onSignupClick={() => navigate('/signup')} />
      <AccessibilityPanel />
    </div>
  );
};

export default Home;
